import { render, staticRenderFns } from "./lightingSetting.vue?vue&type=template&id=ae2b4a1e&scoped=true"
import script from "./lightingSetting.vue?vue&type=script&lang=js"
export * from "./lightingSetting.vue?vue&type=script&lang=js"
import style0 from "./lightingSetting.vue?vue&type=style&index=0&id=ae2b4a1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2b4a1e",
  null
  
)

export default component.exports